// 結果待ちが満了した終端（#7709）。閉じる/閉じないの判定材料を同梱する。
// linkAlive: true=probe成功 / false=probe失敗・cap超過 / null=probe非実施。
// sawAnyFrame: true=write後に何か観測(malformed含む) / false=無観測 / null=V14で判定不使用。
// timedOutOnSchedule: true=タイマが定刻に発火（ランタイムが窓の間稼働=受信機健全の肯定的証拠）
//   / false=大幅遅延（suspend 検出） / null=V14（不使用）
export type ResultWaitTimeoutExceptionOptions = {
  forcedUnlock: boolean
  linkAlive: boolean | null
  sawAnyFrame: boolean | null
  timedOutOnSchedule: boolean | null
  originalError?: unknown
}

export class ResultWaitTimeoutException extends Error {
  readonly forcedUnlock: boolean
  readonly linkAlive: boolean | null
  readonly sawAnyFrame: boolean | null
  readonly timedOutOnSchedule: boolean | null
  readonly originalError?: unknown
  // named object 引数。boolean 3連の positional は転置事故（引数の順序を1つ間違えても
  // 型エラーにならない）の温床になるため、フィールド名で埋めさせる。
  constructor(options: ResultWaitTimeoutExceptionOptions) {
    super('stand result wait timed out')
    this.name = 'ResultWaitTimeoutException'
    this.forcedUnlock = options.forcedUnlock
    this.linkAlive = options.linkAlive
    this.sawAnyFrame = options.sawAnyFrame
    this.timedOutOnSchedule = options.timedOutOnSchedule
    this.originalError = options.originalError
    // es5 ターゲットで instanceof を機能させる
    Object.setPrototypeOf(this, ResultWaitTimeoutException.prototype)
  }
}
